import { set } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

const calculateTimeLeft = (targetDate: Date, timezone?: string): string => {
  const currentDate = timezone ? toZonedTime(new Date(), timezone) : new Date()
  const targetDateAt8AM = set(targetDate, { hours: 8, minutes: 0, seconds: 0, milliseconds: 0 })
  const difference = +targetDateAt8AM - +currentDate
  let timeLeft = ''

  if (difference > 0) {
    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
    const minutes = Math.floor((difference / 1000 / 60) % 60)

    timeLeft = `${days} days ${hours} hrs ${minutes} mins`
  } else {
    timeLeft = ''
  }

  return timeLeft
}

export {
  calculateTimeLeft
}
